export interface ISdkEventHandlersStore {
  setAppsToRefresh(applicaitonIds: number[]): void;
  appsToRefresh: number[];
  setShouldRefreshGeneralInfo(shouldRefreshGeneralInfo: boolean): void;
  shouldRefreshGeneralInfo: boolean;
  clearAppsToRefresh(): void;
}

interface IStore {
  applicationsToRefresh: Set<string>;
  shouldRefreshGeneralInfo: boolean;
}

export class SdkEventHandlersStore {
  store: IStore = {
    applicationsToRefresh: new Set<string>(),
    shouldRefreshGeneralInfo: false,
  };

  setAppsToRefresh(appDefinitionIds: string[]): void {
    appDefinitionIds.forEach((appDefinitionId) => {
      this.store.applicationsToRefresh.add(appDefinitionId);
    });
  }

  get appsToRefresh(): string[] {
    return Array.from(this.store.applicationsToRefresh);
  }

  setShouldRefreshGeneralInfo(shouldRefreshGeneralInfo: boolean): void {
    this.store.shouldRefreshGeneralInfo = shouldRefreshGeneralInfo;
  }

  get shouldRefreshGeneralInfo(): boolean {
    return this.store.shouldRefreshGeneralInfo;
  }

  clearAppsToRefresh(): void {
    this.store.applicationsToRefresh.clear();
  }
}

export const sdkEventHandlersStore = new SdkEventHandlersStore();
